import React from 'react';

import { SVGComponentProps } from './svg.types';

const ComingSoonSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <rect width="16" height="16" rx="4.8" fill="#219735" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 4.5C6 4.22386 6.22386 4 6.5 4H9.50187C9.77802 4 10.0019 4.22386 10.0019 4.5V5.68796C10.0019 5.70878 10.0006 5.72944 9.99804 5.74984H6.00384C6.0013 5.72944 6 5.70878 6 5.68796V4.5ZM6.5 3C5.67157 3 5 3.67157 5 4.5V5.68796C5 6.17045 5.2321 6.6235 5.6237 6.90537L7.14515 8.00051L5.62439 9.09515C5.23279 9.37703 5.00069 9.83007 5.00069 10.3126V11.5005C5.00069 12.329 5.67226 13.0005 6.50069 13.0005H9.50256C10.331 13.0005 11.0026 12.329 11.0026 11.5005V10.3126C11.0026 9.83007 10.7705 9.37703 10.3789 9.09515L8.85742 8.00002L10.3782 6.90537C10.7698 6.6235 11.0019 6.17045 11.0019 5.68796V4.5C11.0019 3.67157 10.3303 3 9.50187 3H6.5ZM6.00069 11.2735H10.0026V10.3126C10.0026 10.1517 9.9252 10.0007 9.79466 9.90676L8.00163 8.61613L6.20859 9.90676C6.07806 10.0007 6.00069 10.1517 6.00069 10.3126V11.2735Z"
          fill="white"
        />
      </svg>
    </span>
  );
};

export default ComingSoonSVG;
